import _ from 'lodash';


export function titleizeSnakeCase(str: string) {
    return str.split('_')
        .filter((word) => word)
        .map((word) => _.capitalize(word))
        .join(' ');
}


export function translate(theEnum: string | undefined, theDict: Record<string, string>) {
    const matchedLabel = theEnum? theDict[theEnum] : null;
    if (matchedLabel) {
        return matchedLabel;
    }

    return theEnum? titleizeSnakeCase(theEnum) : '';
}